module.exports = __webpack_public_path__ + "static/img/system_log_gray.feb6649.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/system_log_gray.svg
// module id = wo30
// module chunks = 1